<template>
  <div class="fts-mobile-chart">
    <fts-spinner full-screen v-if="loading" />
    <fts-mobile-error :error-message="error" v-else-if="error" />
    <fts-dashboard-widget
      :modules="workspaceData.vectors"
      :states="workspaceData.states"
      :users="workspaceData.users"
      :widget-data="workspaceData.widgets"
      readonly
      v-else-if="
        workspaceData &&
        workspaceData.widgets &&
        workspaceData.widgets.some((x) => x.widgetType === 'chart')
      "
    />
    <fts-mobile-error
      error-title="No Chart Found"
      error-message="There is no chart at the moment."
      v-else
    />
  </div>
</template>

<script>
import axios from 'axios';
import webAppConfig from '../commons/webApp.config';

import FTSMobileError from './FTSMobileError';
import FTSDashboardWidget from '../dashboard/FTSDashboardWidget';
import FTSSpinner from '../elements/FTSSpinner';

let resizeObserver = null;

export default {
  components: {
    'fts-mobile-error': FTSMobileError,
    'fts-dashboard-widget': FTSDashboardWidget,
    'fts-spinner': FTSSpinner
  },
  data: () => ({
    ready: false,
    loading: false,
    interval: null,
    error: null,
    workspaceData: null
  }),
  async mounted() {
    if (this.$route.query.id && this.$route.query.token) {
      resizeObserver = new ResizeObserver(_.debounce(() => {
        try {
          window.eventBus.$emit("dashboard:resize");
        } catch (err) {
          console.warn('ResizeObserver:Dashboard', err);
        }
      }));
      resizeObserver.observe(this.$el);

      try {
        this.loading = true;
        this.error = null;

        const query = this.$route.query;
        let wsId = query.id;
        if(query.runas){
          wsId = `runas:${query.id}:${query.runas}`;
        }

        const res = await axios.get(`${webAppConfig.baseURL}/api/workspace/${query.id}`, {
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${query.token}`,
            "tz": Intl.DateTimeFormat().resolvedOptions().timeZone,
            "wsId": wsId,
          }
        });
        this.workspaceData = res.data;
        this.interval = setInterval(() => {
          window.eventBus.$emit("refreshChartWidgetLastUpdated");
        }, 60000);
      } catch(err) {
        if (
          err.response &&
          (err.response.status === 400 || err.response.status === 401) &&
          err.response.data &&
          err.response.data.message
        ) {
          this.error = err.response.data.message;
        } else {
          this.error = "Page you trying to access is unavailable."
        }
      } finally {
        this.loading = false;
      }
    } else {
      this.error = "Page you trying to access is unavailable.\n Error: missing query parameters.";
    }
  },
  beforeDestroy() {
    if (resizeObserver) {
      resizeObserver.unobserve(this.$el);
      resizeObserver.disconnect();
    }
    clearInterval(this.interval);
    this.interval = null;
  }
}
</script>

<style lang="scss" scoped>
.fts-mobile-chart {
  height: 100%;
  padding: 0.5rem;
}
</style>